"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _toCamelCase = _interopRequireDefault(require("../../../../helpers/formatters/toCamelCase"));

var _PolicyStatus = require("./PolicyStatus.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var policyIconMappings = {
  pendingCancel: {
    icon: 'exclamation-circle',
    color: 'warning'
  },
  active: {
    icon: 'check-circle',
    color: 'primary'
  },
  pendingActive: {
    icon: 'check-circle',
    color: 'primary'
  },
  cancelled: {
    icon: 'times-circle',
    color: 'danger'
  },
  on: {
    icon: 'check-circle',
    color: 'primary'
  },
  off: {
    icon: 'times-circle',
    color: 'danger'
  }
};

var PolicyStatus = function PolicyStatus(_ref) {
  var className = _ref.className,
      noBorder = _ref.noBorder,
      status = _ref.status,
      statusDate = _ref.statusDate,
      dataTestId = _ref.dataTestId,
      props = _objectWithoutProperties(_ref, ["className", "noBorder", "status", "statusDate", "dataTestId"]);

  var normalized = (0, _toCamelCase.default)(status);
  var dateStr;

  switch (statusDate && statusDate.constructor.name) {
    case 'String':
      dateStr = statusDate;
      break;

    case 'Date':
      dateStr = statusDate.toLocaleDateString();
      break;

    case 'Moment':
      dateStr = statusDate.toDate().toLocaleDateString();
      break;

    default:
      dateStr = undefined;
  }

  var iconData = policyIconMappings[normalized];
  return /*#__PURE__*/_react.default.createElement(_PolicyStatus.Wrapper, _extends({}, props, {
    className: className
  }), iconData && /*#__PURE__*/_react.default.createElement(_PolicyStatus.StyledIcon, {
    className: "override",
    colorTheme: iconData.color,
    dataTestId: "policy-status-".concat(dataTestId),
    iconName: iconData.icon,
    noBorder: noBorder
  }), /*#__PURE__*/_react.default.createElement(_PolicyStatus.Content, null, status, dateStr && " (".concat(dateStr, ")")));
};

PolicyStatus.propTypes = {
  /** hook for style overrides */
  className: _propTypes.default.string,

  /** hook to disable the border when displaying over white(ish) background */
  noBorder: _propTypes.default.bool,

  /** Policy status - must be one of the following - case insensitive:
   *    active
   *    cancelled
   *    expired
   *    future effective
   *    pending cancel
   */
  status: _propTypes.default.string.isRequired,

  /** If an effective date needs to be displayed, provide that here
   *    If passed in as a string, the value will be passed through untouched
   *    If passed in as a JS Date, .toLocalDateString() will be invoked for displaying
   *    If passed in as a Moment, .toDate().toLocalDateString() will be invoked for displaying
   */
  statusDate: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date), _propTypes.default.instanceOf(_moment.default)]),

  /** standard test id hook */
  dataTestId: _propTypes.default.string.isRequired
};
PolicyStatus.defaultProps = {
  className: undefined,
  noBorder: false,
  statusDate: undefined
};
var _default = PolicyStatus;
exports.default = _default;